import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import Select from '@/components/ui/Select/Select';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const POLICY_TYPE = {
  PERPETRATOR_LIABILITY: 'perpetrator_liability', // OC sprawcy
  PERPETRATOR_VEHICLE_LIABILITY: 'perpetrator_vehicle_liability', // OC pojazdu sprawcy
  BUILDING_MANAGER_LIABILITY: 'building_manager_liability', // OC zarządcy budynku
  OWN_POLICY: 'own_policy', // Polisa własna
  AGRICULTURAL_POLICY: 'agricultural_policy', // Polisa rolnicza
} as const;

export const POLICY_TYPE_NAME = 'policy_type';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const SelectPolicyType: FC<Props> = ({ name = POLICY_TYPE_NAME }) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel>{i18n.t('Wskaż typ polisy')}</FormLabel>
          <FormControl>
            <Select
              data-testid={`${name}-select`}
              {...field}
              placeholder={i18n.t('Wybierz')}
              success={!fieldState.error && field.value}
              options={[
                {
                  label: i18n.t('OC sprawcy'),
                  value: POLICY_TYPE.PERPETRATOR_LIABILITY,
                },
                {
                  label: i18n.t('OC pojazdu sprawcy'),
                  value: POLICY_TYPE.PERPETRATOR_VEHICLE_LIABILITY,
                },
                {
                  label: i18n.t('Polisa własna'),
                  value: POLICY_TYPE.OWN_POLICY,
                },
                {
                  label: i18n.t('Polisa rolnicza'),
                  value: POLICY_TYPE.AGRICULTURAL_POLICY,
                },
                {
                  label: i18n.t('OC zarządcy budynku'),
                  value: POLICY_TYPE.BUILDING_MANAGER_LIABILITY,
                },
              ]}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
